var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightNoFill = function SvgArrowRightNoFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 17,
    fill: "none",
    viewBox: "0 0 10 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.256 1.156 6.79 7.088c.15.186.26.408.26.631a.88.88 0 0 1-.26.594l-6.79 7.088a.886.886 0 0 1-1.262.037c-.371-.334-.371-.89-.037-1.262l6.234-6.494L.957 2.38a.886.886 0 0 1 .037-1.262.886.886 0 0 1 1.262.037"
  })));
};
export default SvgArrowRightNoFill;